var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkinghour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#021d49;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -1063)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(165 1064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M505.413,723.168v6.022l8.281,3.011",
    transform: "translate(-326.438 349.666)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkinghour);
export default __webpack_public_path__ + "static/media/working hour.b1cbd5eed218d20780cc6dc55f7855a1.svg";
export { ForwardRef as ReactComponent };